export default __webpack_public_path__ + "static/media/arrow-left.4ddf5f06.svg";